<template>
  <div class="test-selection-view">
    <p>
      Du fühlst dich fit genug für die Theorie Prüfung?<br />
      Der Simulator erstellt deine Prüfung nach dem offiziellen
      Prüfungsmodell<br />
      Auf geht's! Wähle zuerst eine der Kategorien: Grundwissen oder
      B-Führerschein<br />
      Achte auf das Zeitlimit, du hast pro Prüfung nur 30 Minuten Zeit!
    </p>
    <p>Viel Erfolg!</p>
    <ul>
      <li class="ll-button">
        <router-link to="/pruefung/grundwissen"
          ><BaseButton>Grundwissen</BaseButton></router-link
        >
      </li>
      <li class="ll-button">
        <router-link to="/pruefung/b-fuehrerschein"
          ><BaseButton>B-Führerschein</BaseButton></router-link
        >
      </li>
    </ul>
  </div>
</template>

<script>
import BaseButton from "@/components/BaseButton";
import { mapActions } from "vuex";

export default {
  name: "TestSelectionView",
  components: { BaseButton },
  mounted() {
    this.setPageType("test-selection");
  },
  methods: {
    ...mapActions(["setPageType"]),
  },
};
</script>

<style lang="scss" scoped>
.test-selection-view {
  padding: 10px;

  ul {
    display: flex;
    justify-content: space-evenly;
    li {
      width: 40%;
      height: 50px;
      position: relative;
      overflow: hidden;
      &:after {
        width: 0;
        height: 0;
        transition: all 0.3s ease-in-out;
        content: "";
      }

      /*&:hover {*/
      /*&:after {*/
      /*position: absolute;*/
      /*background: $blue;*/
      /*height: 150%;*/
      /*width: 150%;*/
      /*content: '';*/
      /*border-radius: 100%;*/
      /*[>opacity: 0.3;<]*/
      /*z-index: 0;*/
      /*}*/
      /*}*/
      a {
        color: #ffffff;
        position: absolute;
        z-index: 1;
        /*font-size: 18px;*/
      }
    }
  }
}
</style>
